import { render, staticRenderFns } from "./seguros.vue?vue&type=template&id=b69eaa6c"
import script from "./seguros.vue?vue&type=script&lang=js"
export * from "./seguros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports